import $ from "jquery";
import Swiper from "swiper";

import {
  Mousewheel,
  EffectCreative,
  Navigation,
  EffectFade,
  Pagination,
  Autoplay,
} from "swiper/modules";

export default class SideBySideCarousel {
  $el = $("section.side-by-side-carousel");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.setupCarousel();
    console.log("sie-by-sihde");
  }

  setupCarousel() {
    Swiper.use([
      Mousewheel,
      EffectCreative,
      Navigation,
      EffectFade,
      Pagination,
      Autoplay,
    ]);

    const prev = this.$el.find(".swiper-prev").get(0);
    const next = this.$el.find(".swiper-next").get(0);

    const $carousel = this.$el.find(".swiper-sbs").get(0);

    new Swiper($carousel, {
      slidesPerView: 1,
      spaceBetween: 30,
      effect: "fade",
      loop: true,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: true,
      },
      navigation: {
        nextEl: next,
        prevEl: prev,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}
